import React, { ComponentType } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { HistoryScreen, TeleassistanceDetailScreen } from './HistoryScreens';
import { TNavigationStack } from 'app/types';
import { colorPalette } from '@shared/config/colorsConfig';

type ScreenConfig = { name: keyof TNavigationStack; component: ComponentType<any>; options: object };

const Stack = createNativeStackNavigator<TNavigationStack>();

const HISTORY_SCREENS: ScreenConfig[] = [
  {
    name: 'History',
    component: HistoryScreen,
    options: { headerShown: false },
  },
  {
    name: 'TeleassistanceDetailScreen',
    component: TeleassistanceDetailScreen,
    options: { headerShown: false },
  },
];

export const HISTORY_SCREEN_NAMES: string[] = HISTORY_SCREENS.map(s => s.name);

export default function HistoryNavigator() {
  return (
    <Stack.Navigator screenOptions={{ contentStyle: { backgroundColor: colorPalette.white } }}>
      {HISTORY_SCREENS.map((screen) => (
        <Stack.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={screen.options}
        />
      ))}
    </Stack.Navigator>
  );
}
